// Below Tailwind's sm breakpoint the app uses the phone layout (docs/design/SPEC.md, decision 6).
import { readonly, ref } from 'vue';

const query = window.matchMedia('(max-width: 639.98px)');
const phone = ref(query.matches);
query.addEventListener('change', (event) => {
  phone.value = event.matches;
});

export const isPhone = readonly(phone);
